import { PageHero, PricingSection } from './shared'

export function PricingPage() {
  return (
    <>
      <PageHero
        title="Clear costs. Start with the smallest useful version."
        copy="DAWN is set up around the work your business actually needs help with. Begin with one clear problem, prove the value and add more only when it makes sense."
      />
      <PricingSection />
    </>
  )
}
